import apiClient from '@/repositories/apiClient';
import { api } from './api';

// Two-step upload identical to holidayMedia:
// 1. multipart upload returns a temp filename (plain async fn — multipart
//    can't be serialised through axiosBaseQuery)
// 2. POST registers the row + queues conversion; frontend polls show until
//    `status` flips to ready/failed.
export const uploadNewsMediaFile = async (file, onProgress) => {
  const form = new FormData();
  form.append('file', file);
  const response = await apiClient({
    url: '/news-media/upload',
    method: 'POST',
    data: form,
    headers: { 'Content-Type': 'multipart/form-data' },
    onUploadProgress: (e) => {
      if (onProgress && e.total) {
        onProgress(Math.round((e.loaded * 100) / e.total));
      }
    },
  });
  return response.data;
};

export const newsMediaApi = api.injectEndpoints({
  endpoints: (build) => ({
    createNewsMedia: build.mutation({
      query: (body) => ({
        url: 'news-media',
        method: 'POST',
        body: JSON.stringify(body),
      }),
    }),
    getNewsMedia: build.query({
      query: (id) => ({ url: `news-media/${id}`, method: 'GET' }),
      transformResponse: (r) => r.data,
    }),
    deleteNewsMedia: build.mutation({
      query: (id) => ({ url: `news-media/${id}`, method: 'DELETE' }),
    }),
  }),
});

export const {
  useCreateNewsMediaMutation,
  useGetNewsMediaQuery,
  useLazyGetNewsMediaQuery,
  useDeleteNewsMediaMutation,
} = newsMediaApi;
